import { SafariObject } from '../base-object/models/app/safari-object-base';

export class IdName extends SafariObject {
  name: string;
  order?: number;
  isActive?: boolean;

  // ADDITIONAL PROPS:
  // Note - dropdowns can have additional props that will have different names in the API
  // Due to this we don't store them as strongly typed properties here but we will load them
  // so that they will be available in redux state.
  // They can be accessed as any other property via DropdownPipe
}
